/* this is the custom selectmenu widget extension add multiline and css theming support */



var multilineSelectmenu = $.widget("ui.multilineSelectmenu", $.ui.selectmenu, {
    _setText: function (element, value) {
        if (value) {
            if (value.indexOf('|') !== -1) {
                var lines = value.split('|');
                value = '<span class="ui-selectmenu-menu-item-header">' + lines[0].trim() + '</span>';
                let newvalue = value.replace('(','<span class="smalltext">(');
                let newvalue2 = newvalue.replace(')',')</span>');
                for (var i = 1; i < lines.length; i++) {
                    value = newvalue2 + '<span class="ui-selectmenu-menu-item-content">' + lines[i].trim() + '</span>';
                }
            }
            element.html(value);
        } else {
            element.html("&#160;");
        }
    },
    
    _renderItem: function(ul, item) {
        var li = $("<li>");
        var wrapper = $("<div>", { class: "ui-menu-item-wrapper" });
        
        // Use the existing _setText logic for the main content
        this._setText(wrapper, item.label);
        
        // Check for benefit message on the original option
        var originalOption = item.element;
        if (originalOption && originalOption.length) {
            var benefitMessage = originalOption.data("benefit-message");
            
            if (benefitMessage) {
                var badgeClass = benefitMessage.toLowerCase().replace(/\s+/g, '-');
                var badge = $("<span>", {
                    class: "variant-benefit-badge variant-benefit-badge--" + badgeClass,
                    text: benefitMessage
                });
                
                // Check if this product is in an even position in the grid
                var $gridItem = this.element.closest('.grid-product');
                if ($gridItem.length) {
                    var index = $gridItem.parent().children('.grid-product').index($gridItem);
                    if ((index + 1) % 2 === 0) {
                        badge.addClass('variant-benefit-badge--left');
                    }
                }
                
                li.append(badge);
                li.addClass('has-benefit-badge');
            }
        }
        
        return li.append(wrapper).appendTo(ul);
    }
});